import { Component, input } from '@angular/core';
import {
  InvoiceHandlingMode,
  SectionType,
} from '../../../../../features/invoice-theme/theme.types';

@Component({
  selector: 'app-invoice-viewer',
  standalone: false,
  templateUrl: './invoice-viewer.component.html',
  styleUrl: './invoice-viewer.component.scss',
})
export class InvoiceViewerComponent {
  // Inputs
  type = input.required<SectionType>();
  mode = input.required<InvoiceHandlingMode>();

  public readonly SectionType = SectionType;
}
